import styled from 'styled-components';
import { BREAKPOINTS } from '../../../app/appConstants';

/**
 * Top nav — muted chrome (not accent). Links use `.item` so GlobalLinksStyled skips them.
 * Aligned with affilers-admin-fe TopMenuStyled.
 */
export const MenuStyled = styled.nav`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0;

    .item {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        color: var(--color-white-60);
        font-size: var(--font-size-md);
        font-weight: 600;
        line-height: 24px;
        text-decoration: none;
        border-bottom: 2px solid transparent;
        padding: var(--space-4) var(--space-2);

        svg {
            fill: currentColor;
            flex-shrink: 0;
        }

        &:hover {
            color: var(--color-white-95);
        }

        &.active {
            color: var(--color-white-95);
            border-bottom-color: var(--color-white);
        }

        @media (max-width: ${BREAKPOINTS.medium}px) {
            padding: var(--space-2) var(--space-1);
        }
    }
`;
